import { EventIconAndTime } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { MatchPlayerNameAndScore  } from "@components/StatsConsole/Widgets/OverviewWidget/parts/MatchPlayerNameAndScore";
import { formatEventTime } from "@utils/functions";
import { IMatchGoalPenaltyProps, IMatchGoalProps } from "@components/StatsConsole/Widgets/OverviewWidget/parts/interfaces";


const MatchEventPenaltyHome = ({ home_score, away_score, time, goalscorer, event_type, isPlusSignNeeded = false }: IMatchGoalPenaltyProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    return (
        <div className='flex justify-start mx-[16px] mb-[8px] min-h-[34px] max-h-[34px]'>
            <EventIconAndTime iconName={event_type} time={formattedTime} />
            <MatchPlayerNameAndScore 
                ml="8px" 
                mr="0px" 
                startPosition='start' 
                event_type={event_type} 
                player={goalscorer} 
                homeScore={home_score}
                awayScore={away_score}
                isHomeGoal={true}
            />
        </div>
    )
}

export default MatchEventPenaltyHome;
